module.exports = __webpack_public_path__ + "static/img/平面产品拍摄.9454472.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10010/平面产品拍摄.png
// module id = WFnb
// module chunks = 1